import { render } from "./FileBlock.vue?vue&type=template&id=b811dce8"
import script from "./FileBlock.vue?vue&type=script&lang=js"
export * from "./FileBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__